import React from 'react';

import styled from 'styled-components';

import { useWorkflowBuilderContext } from '../wizard/builder-context';

import { ActionSection } from './sections/action-section';
import { ConditionalSection } from './sections/conditional-section';
import { TimeDelaySection } from './sections/time-delay-section';
import { TriggerSection } from './sections/trigger-section';
import { SummarySidebarContainer, SummarySidebarHeading, SummarySideBarHeadingContainer } from './styles';

import type { NodeType } from '../wizard/builder-context';

const summarySidebarHeading: Record<NodeType, string> = {
  action: 'Action',
  conditional: 'Conditional split',
  timeDelay: 'Timing',
  trigger: 'Trigger',
};

export function WorkflowCampaignBuilderSummarySidebar() {
  const [builderState] = useWorkflowBuilderContext();
  const { selectedNode } = builderState;

  const selectedNodeType = selectedNode?.type ?? '';
  const headingLabel = summarySidebarHeading[selectedNodeType];

  return (
    <BorderedSummarySidebarContainer>
      {selectedNodeType && (
        <SummarySideBarHeadingContainer>
          <SummarySidebarHeading>{headingLabel}</SummarySidebarHeading>
        </SummarySideBarHeadingContainer>
      )}

      {selectedNode?.data?.nodeType === 'trigger' && <TriggerSection />}
      {selectedNode?.data?.nodeType === 'action' && (
        <ActionSection nodeData={selectedNode.data} selectedNodeId={selectedNode.id} />
      )}
      {selectedNode?.data?.nodeType === 'conditional' && (
        <ConditionalSection nodeData={selectedNode.data} selectedNodeId={selectedNode.id} />
      )}
      {selectedNode?.data?.nodeType === 'timeDelay' && (
        <TimeDelaySection nodeData={selectedNode.data} selectedNodeId={selectedNode.id} />
      )}
    </BorderedSummarySidebarContainer>
  );
}

const BorderedSummarySidebarContainer = styled(SummarySidebarContainer)`
  border: 1px solid var(--color-gray-20);
`;
